// =============================================================================
// CHAT LIBRE - Agent Conformité (Mode Conversationnel)
// Utilise le pattern unifié CxOChatPanel
// =============================================================================
import CxOChatPanel from "../direction/CxOChatPanel";

export default function ChatLibrePanel() {
  return <CxOChatPanel cxoType="compliance" />;
}
